// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCAnGPhnkzqtU9mGh2C4FTDxRN0aZJZFrE",
  authDomain: "open-borders---ga4-2b3cc.firebaseapp.com",
  projectId: "open-borders---ga4-2b3cc",
  storageBucket: "open-borders---ga4-2b3cc.appspot.com",
  messagingSenderId: "574851177840",
  appId: "1:574851177840:web:48dd5f04c867d99b72c3b5",
  measurementId: "G-HVT3QN7RZ0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);